import { useMemo } from "react";
import Slick from "./Slick";
import styles from "./index.module.less";
export default function Cooperation({ config, isMobile }) {
  const cooperate = useMemo(() => {
    if (isMobile) {
      // 移动端不需要一列一列滚动展示，所以合并为一个数组
      return config?.cooperate.reduce((result, val) => {
        return result.concat(val.list);
      }, []);
    } else {
      return config?.cooperate;
    }
  }, [config, isMobile]);
  return (
    <div className={styles.cooperateConent}>
      <header>
        <span>和优秀的企业一起</span>
        <span className={styles.exclusiveColor}>高效设计</span>
      </header>
      {isMobile
        ? cooperate?.map((cooperate, index) => {
            return (
              <div className={styles.cooperateCard} key={index}>
                <img src={cooperate?.img?.[0]?.url} alt="" />
              </div>
            );
          })
        : cooperate?.map((cooperate, index) => {
            return (
              <Slick cooperate={cooperate} key={index} num={index}></Slick>
            );
          })}
    </div>
  );
}
